import angular from 'angular';
import template from './searchDataModalView.html';
import logger from '../../../shared/logger';
import './style.scss';

export class searchDataModalCtrl {
    /* @ngInject */
    constructor($scope, CandidateService) {
        this.$scope = $scope;
        this.candidateService = CandidateService;
    }

    async $onInit() {
        this.isLoading = true;
        const { searchFilter, searchKPIs } = this.resolve;
        this.searchKPIs = searchKPIs;

        const extrapolationFilter = { ...searchFilter, cascadingSearch: false };

        try {
            const { result: extrapolationData } = await this.candidateService.getExtrapolatedSearchData(extrapolationFilter);
            this.extrapolationData = extrapolationData || {};
        } catch (error) {
            logger.error(error);
        } finally {
            this.isLoading = false;
            this.$scope.$evalAsync();
        }
    }

    close() {
        this.modalInstance.dismiss();
    }
}

export const searchDataModalCtrlConfiguration = {
    controller: searchDataModalCtrl,
    controllerAs: 'searchDataModalCtrl',
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
    template,
};

angular
    .module('TALENYA-FE')
    .component('searchDataModalCtrl', searchDataModalCtrlConfiguration);
